export default __webpack_public_path__ + "static/media/h.641d0301.svg";